const positiveOrNull = (amount: number | null | undefined): number | null =>
  amount != null && amount > 0 ? amount : null;

export { positiveOrNull };
